export default {
    getfolderInfoToGetCurrentPath(state) {
        return state.currentPathFolderInfo;
    },
};